// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrentUserProfileWidget_container__LsWXc","user_details_container":"CurrentUserProfileWidget_user_details_container__3LNK1"};